// Lowercase the string and capitalize only the first letter — matches the Marsh cover
// subtitle CSS trick. Used for dynamic report content that may arrive in Title Case or
// ALL CAPS (e.g. hazard class names, industry names).
export function toSentenceCase(value) {
  if (value == null || typeof value !== 'string') return value;
  const trimmed = value.trim();
  if (!trimmed) return value;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

export function usesSentenceCase(themeOrCasing) {
  if (themeOrCasing?.isMarsh) return true;
  const casing = themeOrCasing?.casing ?? themeOrCasing;
  return casing?.heading === 'none' && casing?.label === 'none';
}

export function formatThemeText(value, themeOrCasing) {
  return usesSentenceCase(themeOrCasing) ? toSentenceCase(value) : value;
}

export function getHeadingTextTransform(theme) {
  if (usesSentenceCase(theme)) return 'none';
  return theme.headings?.h1?.textTransform || theme.casing?.heading;
}
